import React, { FC } from 'react';
import { Project } from 'api/project';
import { Page } from 'components/molecules/page';
import { AvatarInviteTrigger } from 'components/organisms/projects/global-invite/avatar-invite-trigger';
import { ProjectPlan } from 'components/organisms/projects/project-plan';
import { useTranslation } from 'hooks/use-translation';
import { TitleWrapper } from './overview';

export const ProjectPlanPage: FC<{ project: Project }> = ({ project }) => {
  return (
    <Page>
      <Page.Header
        compact
        title={
          <TitleWrapper>
            <Page.Header.Title>
              {useTranslation('projects.plan')}
            </Page.Header.Title>
            <AvatarInviteTrigger projectId={project.projectId} showButton />
          </TitleWrapper>
        }
      />
      <Page.Content>
        {project && project.customer ? <ProjectPlan project={project} /> : null}
      </Page.Content>
    </Page>
  );
};
